
import React from "react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/logo";
import { MessageCircle, ShoppingCart } from "lucide-react";

export const Taskbar: React.FC = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 py-4">
      <div className="container max-w-5xl mx-auto px-4">
        <div className="flex items-center justify-between bg-white/20 backdrop-blur-xl rounded-full py-2 px-6 shadow-md border border-white/30">
          <Logo />
          
          <div className="flex items-center space-x-4">
            <Button variant="ghost" size="icon" className="text-gray-800 hover:bg-purple-soft/30 rounded-full">
              <MessageCircle className="h-5 w-5" />
              <span className="sr-only">Discord</span>
            </Button>
            <Button 
              className="bg-gray-800/80 hover:bg-gray-800 text-white rounded-full shadow-sm"
            >
              <ShoppingCart className="mr-2 h-4 w-4" />
              Shop
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};
